import {debounce} from '../_functions'

document.addEventListener("DOMContentLoaded", function (dom) {
    const faqList = dom.target.querySelectorAll('.feed-faq');
    const termsList = dom.target.querySelectorAll('.terms__list');
    const searchInput = dom.target.querySelector('.js-search-input');
    const categorySelect = dom.target.querySelector('.js-category');

    if (faqList.length && searchInput) {
        const filterFaq = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();
            const selectedCategory = categorySelect ? categorySelect.value : '';

            faqList.forEach(faq => {
                const title = faq.querySelector('.feed-faq__inset--header--button');
                const titleText = title ? title.innerText.toLowerCase() : '';

                const matchSearch = searchTerm === '' || titleText.includes(searchTerm);

                if (matchSearch) {
                    faq.classList.remove('hidden');
                } else {
                    faq.classList.add('hidden');
                }
            });

            termsList.forEach((term) => {
                if (term.dataset.categorySlug === selectedCategory || selectedCategory === '') {
                    term.style.display = "grid";
                } else {
                    term.style.display = "none";
                }
            })
        };

        const handleInput = debounce(filterFaq, 300);
        searchInput.addEventListener('input', handleInput);

        if (categorySelect) {
            categorySelect.addEventListener('change', filterFaq);
        }

        filterFaq();
    }
});

